export const CONFIG_STORAGE_KEY = '@App:config';
